/**
 * Window handler store to keep track of an opened window
 * for flows that need to close it later (e.g. deposit NEW_WINDOW flow).
 */
export class WindowHandlerStore {
  private handler: Window | null = null;

  set(window: Window | null) {
    this.handler = window;
  }

  get(): Window | null {
    return this.handler;
  }

  close() {
    if (this.handler && !this.handler.closed) {
      try {
        this.handler.close();
      } catch (error) {}
    }
    this.handler = null;
  }

  clear() {
    this.handler = null;
  }
}

export const depositWindowStore = new WindowHandlerStore();
